import { useLanguage } from "context/LanguageContext";
import CustomCircularProgressBar from "../customCharts/customCircularProgressBar";
import YearNavigator from "../ui/YearNavigator";

const DashboardBenchmarks = ({ orgSubStandards, handleSubBenchMarkClick, selectedOrg, year, setYear, toggleMonth, datasMonths, selectedMonth, selectedMonthIdx }) => {
    const { language } = useLanguage(false);
    
    return (
        <div className="w-full max-h-[87%] h-[87%] flex flex-col bg-[#2d3347] rounded-xl gap-2 p-2" >
            {/* Watoms Benchmark Details Header */}
            <div className="flex justify-between border-yellow-400 border-b pb-1">
                {/* Year Navigator */}
                <div className="flex-1 max-w-1/4 w-[23%] flex justify-center items-center" dir="ltr">
                    <YearNavigator year={year} setYear={setYear} />
                </div>
                {/* Title */}
                <h3 className="flex-1 flex justify-center items-center text-md font-bold text-yellow-400 text-center">
                    {language ? 'Performance Standards Evaluation' : 'تقييم معايير الاداء'}
                </h3>
                {/* Month Navigator */}
                <div className="w-1/3 flex justify-center items-center xl:gap-[18px] gap-[5px]" dir="ltr">
                    {selectedMonthIdx !== 0 ?
                        <button
                            onClick={() => toggleMonth(false)}
                            className=" text-[#0af] cursor-pointer"
                            style={{
                                fontSize: 22,
                                fontWeight: 900,
                                transition: 'background 0.2s',
                            }}
                            title="الشهر السابق"
                        >
                            &#8592;
                        </button>
                        :
                        <div className=" text-[22px] font-black" ></div>
                    }
                    <span className="text-yellow-400" style={{ fontWeight: 700, fontSize: 15, textAlign: 'center', letterSpacing: 1 }}>
                        {selectedMonth?.month}
                    </span>
                    {selectedMonthIdx !== (datasMonths.length - 1) ? <button
                        onClick={() => toggleMonth(true)}
                        style={{
                            color: '#0af',
                            fontSize: 22,
                            fontWeight: 900,
                            cursor: 'pointer',
                            transition: 'background 0.2s',
                        }}
                        title="الشهر التالي"
                    >
                        &#8594;
                    </button> : <div
                        style={{
                            fontSize: 22,
                            fontWeight: 900,
                            display: "hidden",
                        }}></div>}
                </div>
            </div>
            {/* Watoms Benchmark Details Body */}
            <div className="flex h-[90%] flex-col flex-1 gap-1 overflow-hidden">
                {orgSubStandards?.map((data, index) => (
                    <div key={data.code} className="w-full h-1/5 flex flex-col gap-2 overflow-hidden">

                        <div className="w-full h-full flex items-center justify-between gap-2 overflow-hidden">

                            {/* Circular */}
                            <div className="w-[15%] flex justify-center">
                                <CustomCircularProgressBar
                                    value={data.score}
                                    size={60}
                                    color="url(#circularBlueGradient)"
                                    bg="#23263a"
                                    textColor="#fff"
                                />
                            </div>

                            {/* Bars */}
                            <div className="w-[70%] flex flex-col">
                                {data.subData
                                    .map((s) => (
                                        <div key={s.code} className="w-full flex items-center gap-2 overflow-hidden">

                                            <span className="text-sm font-bold text-white w-10 text-right shrink-0">
                                                {s.score}%
                                            </span>

                                            <div className={`flex-1 min-w-0 relative ${selectedOrg?.id !== "All" && "hover:cursor-pointer"}`}
                                                style={{
                                                    height: 12,
                                                    background: '#444652',
                                                    borderRadius: 18,
                                                    overflow: 'hidden',
                                                }}
                                                onClick={() => handleSubBenchMarkClick(s)}
                                            >
                                                <div
                                                    className="h-full rounded-full"
                                                    style={{
                                                        width: `${s.score}%`,
                                                        background: s.color,
                                                    }}
                                                />
                                                <span className="absolute inset-0 flex items-center justify-center text-xs text-white pointer-events-none">
                                                    {s.name}
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                            </div>

                            {/* Rotated Label */}
                            <div className="w-[15%] h-full flex items-center justify-end overflow-visible">
                                <span className="w-full h-full flex justify-center items-center text-sm -rotate-90 text-white text-center">
                                    {data.name}
                                </span>
                            </div>

                        </div>

                        {index !== orgSubStandards.length - 1 && (
                            <div className="w-full border-b border-white" />
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
};

export default DashboardBenchmarks;